import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Startpage from './Startpage';
import Mainpage from './Mainpage';
import Introduction from './Introduction';
import Game from './Game';
import Story from './Story';
import Music from './Music';
import Arcaea from './Arcaea';

const router = createBrowserRouter([
  {
    path: "/",
    element:<Startpage/>
  },
  {
    path: "/main",
    element: <Mainpage/>
  },
  {
    path: "/introduction",
    element:<Introduction/>
  },
  {
    path: "/games",
    element: <Game/>
  },
  {
    path: "/story",
    element: <Story/>
  },
  {
    path: "/music",
    element: <Music/>
  },
  {
    path: "/arcaea",
    element: <Arcaea/>
  }
])



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
